import React, { useEffect, useRef, useState } from "react";
import "./Sidebar.css";
import { BsChevronDown } from "react-icons/bs";
import ContactDetails from "./ContactDetails/ContactDetails";
import SocialMedia from "./Social/SocialMedia";
import axios from "axios";

const Sidebar = () => {
  const sidebarRef = useRef(null);
  const [profileImg, setProfileImg] = useState(null);

  useEffect(() => {
    const fetchGitImage = async () => {
      try {
        const res = await axios.get("https://api.github.com/users/MuthuDev4");
        setProfileImg(res.data.avatar_url);
      } catch (err) {
        console.error("GitHub avatar fetch failed", err);
      }
    };
    fetchGitImage();
  }, []);

  const handleSidebarToggle = () => {
    sidebarRef.current.classList.toggle("active");
  };

  return (
    <aside className="sidebar active" data-sidebar ref={sidebarRef}>
      <div className="sidebar-info">
        <figure className="avatar-box">
          <img
            src={profileImg || "/images/my-avatar.png"}
            alt="Muthupalaniappan A"
          />
        </figure>

        <div className="info-content">
          <h1 className="name" title="Muthupalaniappan A">
            Muthu <span>Palaniappan</span>
          </h1>

          {/* UPDATED TITLE */}
          <p className="title">
            Full Stack Developer <br />
            (MERN) – Fresher
          </p>
        </div>

        <button
          className="info-more-btn"
          onClick={handleSidebarToggle}
          data-sidebar-btn
        >
          <span>Show Contacts</span>
          <BsChevronDown />
        </button>
      </div>

      <div className="sidebar-info-more">
        <ContactDetails />
        <SocialMedia />
      </div>
    </aside>
  );
};

export default Sidebar;
